export const TRANSLATIONS_REPORTS = {
  rf: {
    heroTitle: 'reports.rf.hero.title',
    payroll: {
      title: 'global.rf.payroll_report.main',
      description: 'reports.rf.payroll_report.description'
    },
    monthly: {
      title: 'global.rf.monthly_report.main',
      description: 'reports.rf.monthly_report.description'
    },
    tabs: {
      payroll: 'global.rf.payroll_report.main',
      monthly: 'global.rf.monthly_report.main',
      health: 'global.health_report.main'
    },
    toast: {
      success: {
        title: 'reports.rf.download.toast_success.title',
        description: 'monthly_report.toast.success.description'
      },
      error: {
        title: 'global.toast.error.title',
        description: 'global.toast.error.description'
      }
    },
    loadingModal: 'reports.rf.download_loading.description'
  },
  default: {
    heroTitle: 'reports.hero.title',
    title: 'global.monthly_report.main',
    description: 'reports.monthly_report.description',
    health: {
      title: 'global.health_report.main',
      description: 'reports.health_report.description'
    },
    toast: {
      success: {
        title: 'monthly_report.toast.success.title',
        description: 'monthly_report.toast.success.description'
      },
      error: {
        title: 'global.toast.error.title',
        description: 'global.toast.error.description'
      }
    },
    loadingModal: 'reports.download_loading.description'
  },
  frequency: {
    monthly: 'reports.frequency.monthly',
    quarterly: 'reports.frequency.quarterly'
  },
  formatXls: 'reports.format.xls',
  formatPdf: 'reports.format.pdf',
  formatWeb: 'reports.format.web',
  table: {
    header: {
      generationDate: 'global.generation_date.main',
      period: 'global.period',
      cycle: 'rf.global.cycle.main',
      status: 'global.status'
    },
    reportStatus: {
      generated: 'reports.status.generated',
      toGenerate: 'reports.status.to_generate',
      pending: 'status.pending'
    },
    emptyState: {
      title: 'reports.empty_state.title',
      description: 'reports.empty_state.description'
    },
    tooltip: 'reports.table.to_generate.tooltip',
    tooltipWeb: 'reports.table.to_generate_web.tooltip'
  },
  healthReport: {
    loading: 'reports.download_loading.description',
    refundData: {
      title: 'health_report.health_insurance.reimbursments.title',
      totalClaimsLabel: 'health_report.health_insurance.metric_label.total_reimbursments',
      totalSavingsLabel: 'health_report.health_insurance.metric_label.total_amount_reimbursed',
      approvedClaimsLabel: 'health_report.health_insurance.metric_label.approved_reimbursments',
      imedRateLabel: 'health_report.health_insurance.metric_label.imed_reimbursments'
    },
    header: {
      title: 'health_report.header.title',
      description: 'health_report.header.description',
      downloadReportButton: 'metrics.button.download_report'
    },
    footer: {
      generatedDate: 'health_report.footer.generation_date',
      title: 'health_report.footer.title',
      description: 'health_report.footer.description',
      feedback: 'health_report.footer.feedback.label'
    },
    navigation: {
      healthInsurance: 'health_report.navigation.health_insurance',
      habitsAndBenefits: 'health_report.navigation.habits_and_benefits',
      communityAndImpact: 'health_report.navigation.community_and_impact'
    },
    habitsData: {
      title: 'health_report.habits_and_benefits.registered_habits.title',
      stepsLabel: 'health_report.habits_and_benefits.metric_label.steps',
      trainingLabel: 'health_report.habits_and_benefits.metric_label.training',
      meditationLabel: 'health_report.habits_and_benefits.metric_label.meditation'
    },
    benefitsData: {
      title: 'health_report.habits_and_benefits.benefits_interest.title',
      pharmacy: 'health_report.habits_and_benefits.metric_label.pharmacy_interest',
      telemedicine: 'health_report.habits_and_benefits.metric_label.telemedicine_interest',
      healthProtection: 'global.health_protection.main'
    },
    challengeData: {
      header: {
        title: 'health_report.community_and_impact.title',
        description: 'health_report.community_and_impact.description'
      },
      metrics: {
        challenges: 'health_report.community_and_impact.metric_label.employees_in_challenges',
        donations: 'health_report.community_and_impact.metric_label.employees_in_donations'
      },
      challenges: {
        title: 'health_report.community_and_impact.challenges.title',
        users: 'challenges.detail.participants',
        defaultType: 'challenge_type.other_challenges'
      }
    },
    coverage: {
      title: 'health_report.health_insurance.title',
      description: 'health_report.health_insurance.description',
      employeesProtected: 'health_report.health_insurance.metric_label.employees_protected',
      dependentsProtected: 'health_report.health_insurance.metric_label.dependents_protected',
      employeesUnprotected: 'health_report.health_insurance.metric_label.employees_unprotected'
    },
    onboarding: {
      title: 'health_report.habits_and_benefits.title',
      description: 'health_report.habits_and_benefits.description',
      appOnboarding: 'health_report.habits_and_benefits.metric_label.app_onboarding',
      benefitsInterest: 'health_report.habits_and_benefits.metric_label.benefits_interest'
    },
    insuranceUsage: {
      title: 'health_report.health_insurance.insight.insurance_usage.title',
      formulaDescription: 'health_report.health_insurance.insight.insurance_usage.formula_description',
      additionalInfo: 'health_report.health_insurance.insight.insurance_usage.nudge_telemedicine.description'
    },
    refundSuccessData: {
      title: 'health_report.health_insurance.insight.users_with_reimbursements.title',
      description: 'health_report.health_insurance.insight.iusers_with_reimbursements.nudge_helpcenter.description',
      button: 'global.button.go_to_instructive'
    },
    wellbeingSummaryData: {
      preventiveCheckUp: {
        title: 'health_report.habits_and_benefits.insight.medical_check_up.title',
        description: 'health_report.habits_and_benefits.insight.medical_check_up.description'
      },
      physicalActivity: {
        title: 'health_report.habits_and_benefits.insight.physical_activity.title',
        description: 'health_report.habits_and_benefits.insight.physical_activity.description'
      },
      stress: {
        title: 'health_report.habits_and_benefits.insight.stress.title',
        description: 'health_report.habits_and_benefits.insight.stress.description'
      },
      difficultySleeping: {
        title: 'health_report.habits_and_benefits.insight.sleep.title',
        description: 'health_report.habits_and_benefits.insight.sleep.description'
      },
      challengesTextButton: 'create_challenge.hero.title',
      storiesTextButton: 'global.button.activate_story'
    },
    donationsData: {
      title: 'health_report.community_and_impact.donations.title',
      totalDonationsLabel: 'health_report.community_and_impact.metric_label.total_donations',
      totalFoundationsLabel: 'health_report.community_and_impact.metric_label.total_ongs',
      totalDonorUsersLabel: 'health_report.community_and_impact.metric_label.employees_donating'
    },
    challengesSummaryData: {
      meditation: {
        title: 'health_report.community_and_impact.insight.meditation_benefit_interest.title',
        description: 'health_report.community_and_impact.insight.create_challenge.description'
      },
      training: {
        title: 'health_report.community_and_impact.insight.training_benefit_interest.title',
        description: 'health_report.community_and_impact.insight.create_challenge.description'
      },
      challenge: {
        title: 'health_report.community_and_impact.insight.challenge_interest.title',
        description: 'health_report.community_and_impact.insight.create_challenge.description'
      },
      button: 'create_challenge.hero.title'
    },
    telemedicineData: {
      title: 'health_report.mx.health_insurance.telemedicine.title',
      usersAttended: 'health_report.mx.health_insurance.metric_label.users_attended',
      totalSessions: 'health_report.mx.health_insurance.metric_label.total_sessions',
      insight: {
        title: 'health_report.mx.health_insurance.insight.telemedicine_usage.title',
        description: 'health_report.mx.health_insurance.insight.nudge_helpcenter.description',
        button: 'global.button.go_to_instructive'
      }
    }
  }
};
